import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ModalModule, Modal as BaseModal } from 'angular2-modal';

import { Modal } from './modal';
import { BSModalContainer } from './modal-container.component';
import {
  BSMessageModal,
  BSMessageModalTitle,
  BSMessageModalBody,
  BSModalFooter
} from './message-modal.component';

export const /** @type {?} */ providers: any[] = [
  { provide: BaseModal, useClass: Modal },
  { provide: Modal, useClass: Modal }
];
export class BootstrapModalModule {
/**
 * @return {?}
 */
static getProviders(): any[] {
    return providers;
  }
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [ ModalModule, CommonModule ],
  declarations: [
    BSModalFooter,
    BSMessageModalTitle,
    BSMessageModalBody,
    BSMessageModal,
    BSModalContainer
  ],
  providers,
  entryComponents: [
    BSModalContainer,
    BSMessageModal
  ]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function BootstrapModalModule_tsickle_Closure_declarations() {
/** @type {?} */
BootstrapModalModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
BootstrapModalModule.ctorParameters;
}



interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
